import { useCallback } from 'react'

/* global Office */

// Singleton token cache shared across all hook instances
let cachedToken: string | null = null
let tokenPromise: Promise<string> | null = null

async function acquireToken(): Promise<string> {
  try {
    return await Office.auth.getAccessToken({
      allowSignInPrompt: true,
      allowConsentPrompt: true,
      forMSGraphAccess: false,
    })
  } catch (err: unknown) {
    if (import.meta.env.DEV) {
      console.warn('[DEV] SSO token unavailable; proceeding without auth.', err)
      return ''
    }
    throw err
  }
}

export function useSsoToken() {
  const getToken = useCallback(async (): Promise<string> => {
    // Return cached token if available
    if (cachedToken !== null) return cachedToken

    // If a token request is already in flight, wait for it
    if (tokenPromise) return tokenPromise

    tokenPromise = acquireToken()
      .then((token) => {
        if (token) cachedToken = token
        tokenPromise = null
        return token
      })
      .catch((err) => {
        tokenPromise = null
        throw err
      })

    return tokenPromise
  }, [])

  return { getToken }
}
